import angular from 'angular';
import uiRouter from 'angular-ui-router';
import executivesummaryComponent from './executivesummary.component';

let executivesummaryModule = angular.module('executivesummary', [
  uiRouter
])

.component('executivesummary', executivesummaryComponent);

export default executivesummaryModule;


// WEBPACK FOOTER //
// ./client/app/common/reports/executivesummary/executivesummary.js